import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import IconButton from '@material-ui/core/IconButton'
import messages from '../../../messages'
import { FormattedMessage } from 'react-intl'
import { templatenames, PlateProduct } from '../enum'
import styles from '@src/routes/Configurators/utils/styles'
import clsx from 'clsx'
import { useCountriesData } from '@src/utils/useCountriesData'

const useStyles = makeStyles((theme: Theme) => {
  return {
    headerText: {
      textAlign: 'right',
      height: 25,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
    },
    marginLeft: {
      marginLeft: theme.spacing(9),
    },
    contentText: {
      textAlign: 'right',
      marginTop: theme.spacing(0.5),
    },
    download: {
      marginLeft: theme.spacing(-4),
    },
    typeText: {
      textAlign: 'right',
      marginLeft: theme.spacing(4),
      marginTop: theme.spacing(0.5),
    },
    downloadWrapper: {
      textAlign: 'right',
    },
    print: {
      float: 'right',
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.primary.main,
    },
    icon: {
      color: theme.palette.primary.main,
      marginRight: theme.spacing(1),
    },
    multiProductTemplateButton: {
      padding: 2,
      borderRadius: 0,
      '&:hover': {
        background: 'none',
        textDecoration: 'underline',
      },
    },
  }
})

const DownloadTemplate = (props) => {
  const classes = useStyles()
  const { productDetails } = props
  const GlobalCSS = styles()

  const wellsDetails = [
    {
      well: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_WELL_NUMBER96} />
      ),
      channels: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_CHANNEL_NUMBER8} />
      ),
      type: (
        <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_STNADARD} />
      ),
      templateUrl: templatenames.dnaplate_96well_8ch,
    },
    {
      well: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_WELL_NUMBER96} />
      ),
      channels: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_CHANNEL_NUMBER8} />
      ),
      type: <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_MIXED} />,
      templateUrl: templatenames.dnaplate_96well_8ch_mixed,
    },
    {
      well: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_WELL_NUMBER96} />
      ),
      channels: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_CHANNEL_NUMBER12} />
      ),
      type: (
        <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_STNADARD} />
      ),
      templateUrl: templatenames.dnaplate_96well_12ch,
    },
    {
      well: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_WELL_NUMBER96} />
      ),
      channels: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_CHANNEL_NUMBER12} />
      ),
      type: <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_MIXED} />,
      templateUrl: templatenames.dnaplate_96well_12ch_mixed,
    },
    {
      well: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_WELL_NUMBER384} />
      ),
      channels: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_CHANNEL_NUMBER16} />
      ),
      type: (
        <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_STNADARD} />
      ),
      templateUrl: templatenames.dnaplate_384well,
    },
    {
      well: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_WELL_NUMBER384} />
      ),
      channels: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_CHANNEL_NUMBER16} />
      ),
      type: <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_MIXED} />,
      templateUrl: templatenames.dnaplate_384well_mixed,
    },
  ]

  const wellsDetailsWithOutMixedWell = [
    {
      well: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_WELL_NUMBER96} />
      ),
      channels: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_CHANNEL_NUMBER8} />
      ),
      type: (
        <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_STNADARD} />
      ),
      templateUrl:
        productDetails.productType === PlateProduct.DuplexPlate
          ? templatenames.duplexplate_96well_8ch
          : templatenames.dnaplate_96well_8ch,
    },
    {
      well: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_WELL_NUMBER96} />
      ),
      channels: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_CHANNEL_NUMBER12} />
      ),
      type: (
        <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_STNADARD} />
      ),
      templateUrl:
        productDetails.productType === PlateProduct.DuplexPlate
          ? templatenames.duplexplate_96well_12ch
          : templatenames.dnaplate_96well_12ch,
    },
    {
      well: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_WELL_NUMBER384} />
      ),
      channels: (
        <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_CHANNEL_NUMBER16} />
      ),
      type: (
        <FormattedMessage {...messages.CONF_DNAPLATE_PLATE_TYPE_STNADARD} />
      ),
      templateUrl:
        productDetails.productType === PlateProduct.DuplexPlate
          ? templatenames.duplexplate_384well
          : templatenames.dnaplate_384well,
    },
  ]

  const { getCountries } = useCountriesData()
  const countryList = Object.assign(
    {},
    ...getCountries.map((c) => {
      return {
        [c.label]: c.value,
      }
    })
  )

  const {
    Indonesia,
    Cambodia,
    Thailand,
    Philippines,
    India,
    Malaysia,
    Israel,
  } = countryList
  const mixedWellExcludedCountries = [
    Indonesia,
    Cambodia,
    Thailand,
    countryList['Viet Nam'],
    countryList['Brunei'],
    Philippines,
    India,
    countryList['Korea, South'],
    countryList['Hong Kong S.A.R. of China'],
    Malaysia,
    Israel,
  ]

  let templatesToDownload

  const invalid = mixedWellExcludedCountries.includes(
    productDetails.countryCode
  )

  if (productDetails.productType === PlateProduct.DuplexPlate) {
    templatesToDownload = wellsDetailsWithOutMixedWell
  } else {
    if (invalid) {
      templatesToDownload = wellsDetailsWithOutMixedWell
    } else {
      templatesToDownload = wellsDetails
    }
  }
  const wellDetail = templatesToDownload.map((wellDetails, index) => {
    const url = `/configurator-upload/bulk-entry/template/${wellDetails.templateUrl}/${productDetails.countryCode}?isCSR=${productDetails.isCSR}&isCSRSupervisor=${productDetails.isCSRSupervisor}`
    return (
      <Grid container spacing={1} className={classes.marginLeft} key={index}>
        <Grid item xs={1} className={classes.contentText}>
          {wellDetails.well}
        </Grid>
        <Grid item xs={1} className={classes.contentText}>
          {wellDetails.channels}
        </Grid>
        <Grid item xs={1} className={classes.typeText}>
          {wellDetails.type}
        </Grid>
        <Grid item xs={2} className={classes.download}>
          <div className={classes.downloadWrapper}>
            <IconButton
              className={classes.multiProductTemplateButton}
              href={url}
              download
            >
              <CloudDownloadIcon fontSize="small" className={classes.icon} />
              <div className={classes.print}>
                <FormattedMessage {...messages.DOWNLOAD} />
              </div>
            </IconButton>
          </div>
        </Grid>
      </Grid>
    )
  })
  return (
    <div>
      <Grid container spacing={1} className={classes.marginLeft}>
        <Grid
          item
          xs={1}
          className={clsx(classes.headerText, GlobalCSS.globalBlackFontColor)}
        >
          <FormattedMessage {...messages.CONF_DNAPLATES_WELL} />
        </Grid>
        <Grid
          item
          xs={1}
          className={clsx(classes.headerText, GlobalCSS.globalBlackFontColor)}
        >
          <FormattedMessage {...messages.CONF_DNAPLATES_CHANNELS} />
        </Grid>
        <Grid
          item
          xs={1}
          className={clsx(classes.headerText, GlobalCSS.globalBlackFontColor)}
        >
          <FormattedMessage {...messages.CONF_DNAPLATES_TYPE} />
        </Grid>
        <Grid
          item
          xs={2}
          className={clsx(classes.headerText, GlobalCSS.globalBlackFontColor)}
        ></Grid>
      </Grid>
      {wellDetail}
    </div>
  )
}
export default DownloadTemplate
